import { render, staticRenderFns } from "./noticeCenter.vue?vue&type=template&id=be7b8008&scoped=true&"
import script from "./noticeCenter.vue?vue&type=script&lang=js&"
export * from "./noticeCenter.vue?vue&type=script&lang=js&"
import style0 from "./noticeCenter.vue?vue&type=style&index=0&id=be7b8008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b8008",
  null
  
)

export default component.exports